import { Injectable, ComponentFactoryResolver } from '@angular/core';

@Injectable()
export class ModalCreationService {

  private _componentRef = [];
  parentElementForModal;

  constructor(private _resolver: ComponentFactoryResolver) { }

  public setParentElementForModal(parentElementForModal) {

    this.parentElementForModal = parentElementForModal;
  }

  public createModal(modalData) {
    const thisModalAlreadyOpened = this._componentRef.find(ref => {
      return ref.modal.instance.constructor === modalData.component;
    });

    if (!!thisModalAlreadyOpened) {
      return;
    }

    const { component, data, hideOtherModals, success, cancel, error } = modalData;

    if (hideOtherModals && this._componentRef) {

      this.closeModal();
    }

    const factory = this._resolver.resolveComponentFactory(component);
    const compRef = this.parentElementForModal.createComponent(factory);

    if (data) { compRef.instance.data = data; }
    if (success) { compRef.instance.success = success; }
    if (cancel) { compRef.instance.cancel = cancel; }
    if (error) { compRef.instance.error = error; }

    const componentRef = this.patchModalElement(compRef);
    this._componentRef.push(componentRef);
    compRef.instance.modal = componentRef;
    this.preventBackgroundScroll();
  }

  public closeModal(closeAll?: boolean) {

    if (closeAll) {
      this._componentRef.forEach(ref => {
        ref.destroy();
      });
      this._componentRef = [];

      return;
    }
    const lastOpenedModal = this._componentRef[this._componentRef.length - 1];
    if (lastOpenedModal) {
      lastOpenedModal.destroy();
    }
    this._componentRef = this._componentRef.filter(componentRef => componentRef !== lastOpenedModal);
  }

  private patchModalElement(compRef) {
    return {
      modal: compRef,
      data: compRef.data,
      ngOnDestroy: () => { this.restoreBackgroundScroll(); },
      destroy() {
        this.ngOnDestroy();
        this.modal.destroy();
      },
    };
  }

  private preventBackgroundScroll() {

    const body = document.querySelector('body');
    body.style.overflow = 'hidden';
  }

  private restoreBackgroundScroll() {

    const body = document.querySelector('body');
    body.style.overflowX = 'auto';
    body.style.overflowY = 'scroll';
  }
}
